export default __webpack_public_path__ + "static/Graphik-Medium-Web-87f53f3203454fdcbc2a6210f0236a6a.woff";